module.exports = __webpack_public_path__ + "static/img/ic_apply_discount_1.7bb39e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_apply_discount_1.png
// module id = 2TmV
// module chunks = 0